<template>
  <div>
    <SubNav
      :link="{
        text: '&lt; Back to Roles and Permissions',
        href: 'roles',
        class: 'text-danger',
      }"
    />
    <div class="container-fluid p-3">
      <div class="">
        <div v-loading="loading || updating" class="row p-5">
          <div class="col-12 mb-3">
            <h4 class="text-primary mt-2">Edit Role</h4>
            <strong>Role Details</strong>
          </div>
          <div class="col-md-6 mb-3">
            <label for="roleName">Role name*</label>
            <input id="roleName" v-model="roleName" type="text" class="form-control" />
          </div>
          <div class="col-12 mb-3">
            <p>Permissions</p>
            <div class="row">
              <div v-for="perm in perms" :key="perm.name" class="col-6 col-md-4">
                <input
                  :id="perm.name.replace(' ', '-')"
                  v-model="perm.selected"
                  type="checkbox"
                  class="mr-2"
                />
                <label :for="perm.name.replace(' ', '-')">{{ perm.name }}</label>
              </div>
            </div>
          </div>
          <div class="col-12">
            <b-button class="btn btn-primary px-5 py-2 mr-3" @click="onUpdate"
              >Update Role</b-button
            >
            <b-button variant="outline-danger" class="btn py-2 border-0" @click="onDelete"
              >Delete Role</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubNav from "../../components/SubNav.vue";

import mixin from "../../mixins/dashboard-data";

export default {
  name: "Profile",
  components: { SubNav },
  mixins: [mixin],
  data() {
    return {
      roleName: "",
      perms: [],
      updating: false,
      loading: false,
    };
  },
  computed: {
    title() {
      return "Roles and Permissions";
    },
    description() {
      return 'Manage Existing Roles and Permissions, by clicking on the "Edit Roles" Link';
    },
  },
  async mounted() {
    if (!this.roles.length) return this.$router.push("/users/roles");
    const role = this.roles.find((r) => r.id == this.$route.query.role);
    this.roleName = role.name;
    try {
      this.loading = true;
      if (!this.permissions.length) await this.loadPermissions();
      this.perms = this.permissions
        .map((p) => ({
          ...p,
          selected: role.permissions.some((pm) => pm.id == p.id),
        }))
        .reverse();
    } catch (error) {
      console.log(error);
      this.$notify.error("Unable to load permissions");
    }
    this.loading = false;
  },
  methods: {
    onUpdate() {
      this.updating = true;
      this.updateRole({
        id: this.$route.query.role,
        role: {
          name: this.roleName,
          permissions: this.perms.filter((p) => p.selected).map((p) => p.id),
        },
      })
        .then(() => {
          this.$notify.success("Success");
          this.$router.push("/users/roles");
        })
        .catch((err) => {
          console.log(err);
          this.$notify.error("An error occured!");
        })
        .finally(() => {
          this.updating = false;
        });
    },
    onDelete() {
      this.updating = true;
      this.deleteRole(this.$route.query.role)
        .then(() => {
          this.$notify.success("Role deleted successfully");
          this.$router.push("/users/roles");
        })
        .catch((err) => {
          console.log(err);
          this.$notify.error("An error occured!");
        })
        .finally(() => {
          this.updating = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.user-roles {
  max-height: 270px;
  overflow-y: auto;
  scroll-behavior: smooth;
}
</style>
